import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'noData',
    templateUrl: './no-avaliable-data.component.html',
    styleUrls: ['./no-avaliable-data.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class NoAvaliableDataComponent {}
